import { IconName, Link } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { EmployeeLoadTypeEnum, useRepositoryMutation } from '@mews-commander/data-access';
import { useUserType } from '../../hooks/useUserType';

export const ResendInviteButton = ({ email }: { email: string }) => {
    const { isPortfolioCentralUser } = useUserType();

    const resendEmail = useRepositoryMutation('userProfiles', 'resendWelcomeEmail');

    const handleResendEmail = () =>
        resendEmail.mutate(
            {
                emails: [email],
                employeeLoadType: isPortfolioCentralUser
                    ? EmployeeLoadTypeEnum.PortfolioEmployees
                    : EmployeeLoadTypeEnum.PropertyEmployees,
            },
            {
                onSuccess: () => {
                    showSuccessAlert({
                        description: <LocalizedText textKey={TextKey.UserProfileResendInviteEmailSuccess} />,
                    });
                },
            }
        );

    return (
        <Link as="button" icon={IconName.Mails} onClick={handleResendEmail} variant="basic" size="small" standalone>
            <LocalizedText textKey={TextKey.UserProfileResendInviteEmailText} />
        </Link>
    );
};
